import { Fonts } from '../../theme';

export default {
  inputDefault: {

  },
  inputDefaultMap: {
    width: 300,
    height: 40,
    borderRadius: 4,
    fontFamily: Fonts.type.KanitRegular,
    fontSize: Fonts.size.text14,
  },
  inputWidth150: {
    width: 150,
    height: 40,
    fontFamily: Fonts.type.KanitRegular,
    fontSize: Fonts.size.text14,
  },
  inputTableSearch: {
    width: 180,
    height: 40,
    boxShadow: 'none',
    borderColor: '#D9D9D9',
    fontFamily: 'Kanit-Regular'
  },
  inputArea: {
    width: 300,
    height: 88
  },
};
